import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { ColumnDescription } from "react-bootstrap-table-next";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import {
    CadastrarTipoAgendamentoController,
    DeletarTipoAgendamentoController,
    ListarTipoAgendamentoController,
} from "../../../../../../Controllers/Geral/GestaoDeCadastros/TipoAgendamento/TipoAgendamentoController";
import { ITipoAgendamento } from "../../../../../../Interfaces/Geral/GestaoDeCadastro/TipoAgendamento/TipoAgendamentoInterface";
import SpinnerComponent from "../../../../../Loding/Spinner";
import Table from "../../../../../Table";

export function TipoAgendamento() {
    const { register, handleSubmit, formState, reset } = useForm();
    const [LstObrasCob, setLstObrasCob] = useState<Array<ITipoAgendamento>>();

    useEffect(() => {
        updateList();
    }, []);

    function updateList() {
        ListarTipoAgendamentoController().then((res) => {
            setLstObrasCob(res);
        });
    }

    function handleCadastrarTipoAgendamentoFormSubmit(
        formData: ITipoAgendamento
    ) {
        CadastrarTipoAgendamentoController({
            ID_TIPO_COMPROMISSO: 0,
            DS_TIPO_COMPROMISSO: formData.DS_TIPO_COMPROMISSO,
        }).then(() => {
            updateList();
            reset();
        });
    }

    function RowTable(cell: any, row: ITipoAgendamento) {
        return (
            <div className="rowCapysRC d-flex justify-content-between align-itens-center flex-row">
                <p className="p-3 font-weight-bold">
                    {row.DS_TIPO_COMPROMISSO}
                </p>
                <div>
                    <button
                        className="btn  btn-sm btn-outline-danger font-weight-bold"
                        onClick={() => {
                            Swal.fire({
                                title: "Deseja apagar este Tipo Agendamento?",
                                icon: "info",
                                buttonsStyling: false,
                                confirmButtonText:
                                    "<i class='la la-check'></i> Sim!",
                                showCancelButton: true,
                                cancelButtonText:
                                    "<i class='la la-thumbs-down'></i> Não",
                                customClass: {
                                    confirmButton: "btn btn-outline-success",
                                    cancelButton: "btn btn-default",
                                },
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    DeletarTipoAgendamentoController(
                                        row.ID_TIPO_COMPROMISSO
                                    ).then(() => {
                                        updateList();
                                    });
                                }
                            });
                        }}
                    >
                        <FontAwesomeIcon icon={faTrash} size="lg" />
                    </button>
                </div>
            </div>
        );
    }

    const ColunsTipoAgendamento: Array<ColumnDescription> = [
        {
            dataField: "ID_TIPO_COMPROMISSO",
            text: "Tipo Agendamento",
            formatter: RowTable,
            sort: true,
            isDummyField: true,
        },
    ];

    return LstObrasCob !== undefined ? (
        <div className="">
            <div className="col-12 collapse mb-5" id="collapseForm">
                <h5 className="text-center">Cadastre um Tipo Agendamento</h5>
                <form
                    onSubmit={handleSubmit(
                        handleCadastrarTipoAgendamentoFormSubmit
                    )}
                    className="w-100 d-flex justify-content-between align-itens-center"
                >
                    <div className="w-100 h-100">
                        <input
                            type="text"
                            name="DS_TIPO_COMPROMISSO"
                            className={`form-control placeholder-dark-45 h-100 ${
                                formState.errors.motivo && "is-invalid"
                            }`}
                            placeholder="Tipo Agendamento"
                            ref={register({
                                required: "Insira o Tipo Agendamento",
                            })}
                        />
                    </div>

                    <button className="btn btn-outline-success font-weight-bold ml-2 d-flex align-items-center">
                        <FontAwesomeIcon
                            icon={faPlus}
                            size="lg"
                            className="mr-1"
                        />{" "}
                        Cadastrar
                    </button>
                </form>
            </div>

            <div className="table-responsive-sm">
                <Table
                    keyField="ID_ERP_EMPRESA_OBRA"
                    data={LstObrasCob}
                    columns={ColunsTipoAgendamento}
                    noDataIndication={"Não existe Tipo Agendamento"}
                />
            </div>
        </div>
    ) : (
        <SpinnerComponent />
    );
}
